import './CurriculumBox.scss';
import { ReactComponent as RightArrow } from './../../../../assets/images/right-arrow-svgrepo-com.svg';
import CurriculumBoxProps from "./CurriculumBoxProps";
import { useNavigate } from "react-router-dom";

const CurriculumBox = ({ curricula }: CurriculumBoxProps) => {
  const navigate = useNavigate();

  const goToCurriculum = () => {
    navigate("/curricula/curriculum/" + curricula.entityId);
  };

  return (
    <div key={curricula.templateId} className="d-flex curriculumBox pointer" onClick={goToCurriculum}>
      <div className="content">
        <div className={`curriculumTitle`}>{curricula.templateTitle}</div>
        <div className="subtitleContainer">
          <div className="subtitle groupTitle">{curricula.entityTitle}</div>
          {curricula.numOfTeam > 0 ? <div className="subtitle groupLeaders">Group leaders: {curricula.numOfTeam}</div> : null}
          {curricula.numOfParticipants > 0 ? <div className="subtitle groupMembers">Participants: {curricula.numOfParticipants}</div> : null}
        </div>
      </div>
      <div className="curriculumNavArrow">
        <RightArrow />
      </div>
    </div>
  );
};

export default CurriculumBox;